// extracted by mini-css-extract-plugin
export default {"root":"bV4DeO3ZWL","root_verticalPadding":"OpVFfOEkZr","root_edgeToEdge":"mr6v5IyFLT"};